import { useState } from "react";
import brandLogo from "../../../../assets/images/tnp-logo-neon.png";
import AppLayout from "../../../../shared/components/AppLayout";
import { siteTexts } from "../../../../shared/i18n/siteTexts";
import "./LegalPages.css";

const SECTION_ICONS = [
  "layers",
  "badge",
  "verified_user",
  "person",
  "balance",
  "link",
  "edit_note",
  "gavel",
] as const;

export default function TermsOfUsePage() {
  const terms = siteTexts.legal.termsOfUse;
  const [openSections, setOpenSections] = useState<string[]>(() =>
    terms.sections.map((section) => section.title),
  );

  const toggleSection = (title: string) => {
    setOpenSections((current) =>
      current.includes(title)
        ? current.filter((item) => item !== title)
        : current.concat(title),
    );
  };

  return (
    <AppLayout>
      <main className="legal-terms-page" aria-labelledby="terms-page-title">
        <div className="legal-terms-shell">
          <header className="legal-terms-hero">
            <img className="legal-terms-logo" src={brandLogo} alt="TNP" />
            <div className="legal-terms-hero-content">
              <span
                className="legal-terms-hero-icon material-symbols-outlined"
                aria-hidden="true"
              >
                verified_user
              </span>
              <div>
                <h1 id="terms-page-title">{terms.title}</h1>
                <p>
                  {terms.lastUpdatedLabel}: {terms.lastUpdatedDate}
                </p>
              </div>
            </div>
          </header>

          <section className="legal-terms-intro">
            <span
              className="legal-terms-intro-icon material-symbols-outlined"
              aria-hidden="true"
            >
              article
            </span>
            <div>
              <h2>{terms.introTitle}</h2>
              <p>{terms.introDescription}</p>
              <p>{terms.introReadCarefully}</p>
            </div>
          </section>

          <section className="legal-terms-list" aria-label={terms.title}>
            {terms.sections.map((section, index) => {
              const isOpen = openSections.includes(section.title);
              const panelId = `terms-section-${index}`;
              const buttonId = `terms-section-trigger-${index}`;
              return (
                <article className="legal-terms-section" key={section.title}>
                  <span
                    className="legal-terms-section-icon material-symbols-outlined"
                    aria-hidden="true"
                  >
                    {SECTION_ICONS[index] || "description"}
                  </span>
                  <div className="legal-terms-section-main">
                    <h2>{section.title}</h2>
                    <div
                      id={panelId}
                      role="region"
                      aria-labelledby={buttonId}
                      hidden={!isOpen}
                    >
                      {section.paragraphs.map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                      ))}
                      {"items" in section && section.items && (
                        <ul>
                          {section.items.map((item) => (
                            <li key={item}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                  <button
                    id={buttonId}
                    type="button"
                    className="legal-terms-section-toggle"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    aria-label={`${isOpen ? terms.collapseLabel : terms.expandLabel}: ${section.title}`}
                    onClick={() => toggleSection(section.title)}
                  >
                    <span className="material-symbols-outlined" aria-hidden="true">
                      expand_more
                    </span>
                  </button>
                </article>
              );
            })}
          </section>

          <section className="legal-terms-contact">
            <span
              className="legal-terms-contact-icon material-symbols-outlined"
              aria-hidden="true"
            >
              help
            </span>
            <div>
              <h2>{terms.questionsTitle}</h2>
              <p>{terms.questionsText}</p>
            </div>
            <a className="legal-terms-contact-button" href="mailto:todosnopadel@gmail.com">
              {terms.contactCta}
              <span className="material-symbols-outlined" aria-hidden="true">
                arrow_forward
              </span>
            </a>
          </section>
        </div>
      </main>
    </AppLayout>
  );
}
